import React from 'react';
import { COLORS } from "Constants/BIDashboardConstants.js";

const UnPinIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id='unpin'
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5541 14.2184L18.7695 10.7072L19.9649 11.2646C20.3403 11.4397 20.7865 11.2773 20.9615 10.9019L21.5955 9.5424C21.7705 9.16699 21.6081 8.72076 21.2327 8.5457L13.5291 4.95345C13.1537 4.77839 12.7075 4.94081 12.5324 5.31622L11.8985 6.67568C11.7234 7.05109 11.8858 7.49732 12.2612 7.67237L13.4566 8.22979L11.5482 11.4178C9.8765 11.4159 8.28132 12.0665 7.61122 13.5035C7.43616 13.8789 7.59857 14.3252 7.97398 14.5002L11.8258 16.2963L10.4522 19.242C10.4358 19.2772 10.4278 19.3157 10.4289 19.3545L10.4747 21.031C10.4803 21.2364 10.7187 21.3479 10.88 21.22L12.1936 20.1775C12.224 20.1533 12.2484 20.1225 12.2648 20.0873L13.6384 17.1416L17.4902 18.9377C17.8657 19.1128 18.3119 18.9504 18.4869 18.575C19.1629 17.1253 18.6185 15.4841 17.5541 14.2184Z"
        fill="white"
        stroke={COLORS.oneGp.charcoal}
      />
    </svg>
  );
};

export default UnPinIcon;
